// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewConfirmDocument_wrapper__Um8-R","file":"ViewConfirmDocument_file__LOwU4","size":"ViewConfirmDocument_size__y-wa-"};